<template>
<div>
    <b-card>
        <b-alert variant="danger" :show="errors.length > 0">
            <p v-for="x in errors" v-bind:key="x">{{x}}</p>
        </b-alert>
        <b-form @submit.stop.prevent="onSubmit">
            <div>
                <b-row>
                    <b-col>
                        <b-form-group id="input-group-1" label="کد مشتری: " label-for="input-1">
                            <b-form-input id="input-1" required v-model="Input.code" placeholder="کد مشتری "></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-2" label="نام مشتری: " label-for="input-2">
                            <b-form-input id="input-2" required v-model="Input.name" placeholder="نام مشتری "></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="input-group-3" label="تلفن همراه مشتری: " label-for="input-3">
                            <b-form-input id="input-3" :disabled="Input.id !== 0" required v-model="Input.mobile" placeholder="تلفن همراه مشتری "></b-form-input>
                        </b-form-group>
                    </b-col>

                    <b-col>
                        <b-form-group id="input-group-4" label="ایمیل مشتری: " label-for="input-4">
                            <b-form-input id="input-4" :disabled="Input.id !== 0" required v-model="Input.email" placeholder="ایمیل مشتری "></b-form-input>
                        </b-form-group>
                    </b-col>

                </b-row>
                <b-row>
                    <b-col>
                        <b-form-group id="Type-gr" label="نوع مشتری:" label-for="Type">
                            <MDDropdown v-bind:group="17" v-model="Input.mdid17_type"></MDDropdown>
                        </b-form-group>
                    </b-col>
                    <b-col>
                        <b-form-group id="is_fav-gr" label="مشتری ویژه:" label-for="is_fav">
                            <b-form-select v-model="Input.is_fav" :options="is_favs"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-form-group id="input-group-5" label="توضیحات: " label-for="input-5">
                    <b-form-textarea required id="input-5" v-model="Input.description" placeholder="توضیحات" rows="8"></b-form-textarea>
                </b-form-group>
            </div>

            <br />
            <b-button type="submit" class="mr-3" variant="success">ثبت</b-button>
            <b-button class="mr-3" variant="danger" href="#/Customers">بازگشت</b-button>
        </b-form>
    </b-card>
</div>
</template>

<style>
.aligner {
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>

<script>
import {
    SET_BREADCRUMB
} from "@/core/services/store/breadcrumbs.module";
import httpHelper from "@/helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import MDDropdown from "../../components/MDDropdown";
export default {
    name: "AddCustomer",
    components: {
        persianDate,
        MDDropdown
    },
    data: function () {
        return {
            Input: {
                id: 0,
                code: "",
                name: "",
                mobile: "",
                email: "",
                description: "",
                mdid17_type: "",
                is_fav: "",
            },
            is_favs: [{
                    value: 0,
                    text: 'خیر'
                },
                {
                    value: 1,
                    text: 'بله'
                }
            ],
            errors: []
        };
    },

    methods: {
        onSubmit(evt) {
            this.errors = [];
            if (this.$route.params.id != null) {
                this.Input.id = this.$route.params.id;
            }
            httpHelper.postData("crmcustomer", this.Input).then(response => {
                if (response.success) {
                    this.$router.push("/Customers");
                } else {
                    for (var key in response.error) {
                        response.error[key].forEach(element => {
                            this.errors.push(element);
                        });
                    }
                }
            });
        },

    },
    mounted() {
        if (this.$route.params.id != null) {
            this.$store.dispatch(SET_BREADCRUMB, [{
                    title: "لیست بازاریابی",
                    route: "/Customers"
                },
                {
                    title: "ویرایش مشتری"
                }
            ]);
            httpHelper.getData("crmcustomer?id=" + this.$route.params.id).then(res => {
                if (res.success && res.result !== null) {
                    this.Input = res.result;
                }
            });
        } else {
            this.$store.dispatch(SET_BREADCRUMB, [{
                    title: "لیست بازاریابی",
                    route: "/Customers"
                },
                {
                    title: "مشتری جدید"
                }
            ]);
        }
    }
};
</script>
